// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"faq_wrapper__u0OyO","item":"faq_item__6LnWv"};